const clientType =
window.CS_CONFIG?.clientType && window.CS_CONFIG.clientType !== "#{CLIENT_TYPE}"
  ? window.CS_CONFIG.clientType
  : process.env.REACT_APP_CLIENT_TYPE || "Member";


const branding = {
  id: window.BRANDING?.id  
        && window.BRANDING?.id !== "#{BRAND_ID}"
        ? window.BRANDING.id 
        : process.env.REACT_APP_BRAND_ID,
  name: window.BRANDING?.name  
        && window.BRANDING?.name !== "#{BRAND_NAME}"
        ? window.BRANDING.name 
        : process.env.REACT_APP_BRAND_NAME,
  accountName: window.BRANDING?.accountName
        && window.BRANDING?.accountName !== "#{BRAND_ACCOUNT_NAME}"
        ? window.BRANDING.accountName 
        : process.env.REACT_APP_BRAND_ACCOUNT_NAME,
  color: window.BRANDING?.color
        && window.BRANDING?.color !== "#{BRAND_COLOR}"
        ? window.BRANDING.color 
        : process.env.REACT_APP_BRAND_COLOR
}

branding.logo = branding.id === 'imaginecare' ? '/assets/images/ImagineCareIcon.svg' : branding.id === 'truecare' ? '/assets/images/truecare-logo-primary.svg' : '/assets/images/heart.svg';

branding.urls = branding.id === 'truecare' ?
{
  hipaa: 'https://www.mstruecare.com/ms/about-mstc/legal/hipaa-privacy-practices/',
  termsAndConditions: 'https://www.mstruecare.com/ms/about-mstc/legal/terms-and-conditions/',
  contact: 'https://www.mstruecare.com/ms/members/contact-us/'
} :
{
  hipaa: 'https://www.caresource.com/about-us/legal/hipaa-privacy-practices/',
  termsAndConditions: 'https://www.caresource.com/about-us/legal/terms-and-conditions/',
  contact: 'https://www.caresource.com/members/contact-us/'
}

branding.color = branding.id === "truecare" ? "#00426C" : "#A271B5";

const oktaAuthConfig = {
  // Note: If your app is configured to use the Implicit flow
  // instead of the Authorization Code with Proof of Code Key Exchange (PKCE)
  // you will need to add `pkce: false`
  issuer:
    window.CS_CONFIG?.issuer && window.CS_CONFIG.issuer !== "#{OKTA_ISSUER}"
      ? window.CS_CONFIG.issuer
      : process.env.REACT_APP_ISSUER ||
        "https://caresource-member.oktapreview.com/oauth2/default",
  clientId:
    window.CS_CONFIG?.clientId &&
    window.CS_CONFIG.clientId !== "#{OKTA_CLIENTID}"
      ? window.CS_CONFIG.clientId
      : process.env.REACT_APP_CLIENT_ID || "0oaxtk0t5O5PRpV3l1d6",
  redirectUri: window.location.origin + "/auth/callback",
  memberRedirectUri: window.location.origin + "/authentication/callback"
};

const oktaSignInConfig = {
  baseUrl:
    window.CS_CONFIG?.baseUrl && window.CS_CONFIG.baseUrl !== "#{OKTA_BASEURL}"
      ? window.CS_CONFIG.baseUrl
      : process.env.REACT_APP_BASE_URL ||
        "https://caresource-member.oktapreview.com",
  clientId:
    window.CS_CONFIG?.clientId &&
    window.CS_CONFIG.clientId !== "#{OKTA_CLIENTID}"
      ? window.CS_CONFIG.clientId
      : process.env.REACT_APP_CLIENT_ID || "0oaxtk0t5O5PRpV3l1d6",
  redirectUri: window.location.origin + "/auth/callback",
  logo: branding.id === 'imaginecare' ? "/ImagineCare-logo.svg" : branding.id === 'truecare' ? "/truecare-logo-primary.svg" : clientType === "Provider" ? "/cs_with_partners_logo.svg" : "https://www.caresource.com/wp-content/themes/the-next-generation/assets/images/cs-tertiary-primary.svg",
  logoText: branding.name,
  scope: "openid email offline_access",
  features: {
    registration: false,
    rememberMe: true,
    multiOptionalFactorEnroll: false,
    router: true,
    selfServiceUnlock: true
  },
  authParams: {
    //pkce: false,
    issuer:
      window.CS_CONFIG?.issuer && window.CS_CONFIG.issuer !== "#{OKTA_ISSUER}"
        ? window.CS_CONFIG.issuer
        : process.env.REACT_APP_ISSUER ||
          "https://caresource-member.oktapreview.com/oauth2/default",
    //responseType: "code",
    //display: "page",
    scopes: ["openid", "email", "offline_access"],
  },
  colors: {
    brand: branding.id === 'imaginecare' ? "#34B4E1" : branding.id === 'truecare' ? "#00426c" : clientType === "Provider" ? "#166f8d" : "#9555a5",
  },
  i18n: {
    en: {
      "primaryauth.title": clientType === "Provider" ? "Providers" : `Login to Your ${branding.accountName} Account`,
      "primaryauth.username.placeholder": clientType === "Provider" ? "Email" : "Username",
      "error.username.required": clientType === "Provider" ? "Please enter the email address associated with your Portal account" : "Please enter a username",
      "registration.form.title": clientType === "Provider" ? "Create Account" : `Create ${/^[aeiou]/i.test(branding.accountName) ? 'an' : 'a'} ${branding.accountName} Account`,
      "registration.passwordComplexity.excludeUsername": clientType === "Provider" ? "Does not contain part of username (email)" : "Does not contain part of username",
      "password.forgot.email.or.username.placeholder": "Enter the Email associated with your account",
      "password.forgot.email.or.username.tooltip": "Enter the Email associated with your account",
      "password.forgot.sendEmail": "Reset Password",
      "password.forgot.emailSent.desc": "An Email has been sent to {0} with instructions on resetting your password.",
      "password.forgot.question.submit": clientType === "Provider" ? "Reset Password" : `Reset Your ${branding.accountName} Account Password`,
      "account.unlock.title": clientType === "Provider" ? "Unlock Account" : `Unlock Your ${branding.accountName} Account`,
      "account.unlock.email.or.username.placeholder": "Enter the Email associated with your account",
      "account.unlock.email.or.username.tooltip": "Enter the Email associated with your account",
      "guestLogin.title": "Guest Login",
    },
    es: {
      "primaryauth.title": clientType === "Provider" ? "Providers" : `Iniciar sesión en ${branding.accountName}`,
      "primaryauth.username.placeholder": clientType === "Provider" ? "Correo electrónico" : "Nombre de usuario",
      "error.username.required": clientType === "Provider" ? "Ingrese la dirección de correo electrónico asociada con su cuenta del Portal" : "Ingrese un nombre de usuario",
      "registration.form.title": clientType === "Provider" ? "Crear una cuenta" : `Crear una cuenta ${branding.accountName}`,
      "registration.passwordComplexity.excludeUsername": clientType === "Provider" ? "No contiene parte del nombre de usuario (Correo electrónico)" : "No contiene parte del nombre de usuario.",
      "guestLogin.title": "Acceso de usuario invitado",
    },
  },
  customButtons: [],
  language: function (supportedLanguages, userLanguages) {
    //uses cookie: CS_CurrentUICulture or query param: lang=
    //query param takes precendence

    var regex = new RegExp("[?&]lang(=([^&#]*)|&|#|$)"),
      results = regex.exec(window.location.href);

    var lang = "";

    var name = "CS_CurrentUICulture=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        lang = c.substring(name.length, c.length);
        break;
      }
    }

    if (!!results && !!results[2]) {
      lang = results[2];
    }

    if (supportedLanguages.indexOf(lang) >= 0) return lang;

    lang = lang.substring(0, 2).toLowerCase();

    if (supportedLanguages.indexOf(lang) >= 0) return lang;

    return "en";
  },
};

const env =
  window.CS_CONFIG?.Env && window.CS_CONFIG.Env !== "#{ENV}"
    ? window.CS_CONFIG.Env
    : process.env.REACT_APP_ENV;

const allowedRedirects =
  window.CS_CONFIG?.allowedRedirects &&
  window.CS_CONFIG.allowedRedirects !== "#{DEFAULT_ALLOWED_REDIRECTS}"
    ? window.CS_CONFIG.allowedRedirects
    : process.env.REACT_APP_DEFAULT_ALLOWED_REDIRECTS;

const appConfig = {
    defaultRedirectTo:
        window.CS_CONFIG?.defaultRedirect &&
        window.CS_CONFIG.defaultRedirect !== "#{DEFAULT_REDIRECT}"
            ? window.CS_CONFIG.defaultRedirect
            : process.env.REACT_APP_DEFAULT_REDIRECT || "http://localhost:4200",

    idp:
        window.CS_CONFIG?.oktaIdp && window.CS_CONFIG.oktaIdp !== "#{OKTA_IDP}"
            ? window.CS_CONFIG.oktaIdp
            : process.env.REACT_APP_IDP ||
            "0oabj8tghDOl9Gmdy1d6",
    debugAllowed: env ? !/prd|crt$/.test(env) : false,
    allowedRedirects: allowedRedirects
        ? new RegExp(allowedRedirects)
        : /^(?:https?:\/\/(?:localhost|.*\b.local)\b|https:\/\/.*\b(?:ext)?(?:caresource|imaginecare)\.(?:corp|com)\b)(?::\d+)?(?:\?|\/|$)|^\/.*/,
    isProvider: clientType === "Provider",
    acceptedLanguages:
        window.CS_CONFIG?.acceptedLanguages &&
        window.CS_CONFIG.acceptedLanguages !== "#{ACCEPTED_LANGUAGES}"
            ? JSON.parse(window.CS_CONFIG.acceptedLanguages)
            : {
                  en: ["English", "en", "en-US", "en_US"],
                  es: ["Espanol", "es", "es-US", "es_US"],
              },
};


const featureFlags = {
  newMemberAccessAndAuth: window.FEATURE_FLAGS?.newMemberAccessAndAuth  
                          && window.FEATURE_FLAGS.newMemberAccessAndAuth !== "#{NEW_MEMBER_ACCESS_AUTH}"
                          ? window.FEATURE_FLAGS.newMemberAccessAndAuth 
                          : process.env.REACT_APP_NEW_MEMBER_ACCESS_AUTH
}

const watchtower = {
  cookieDomain: window.WATCHTOWER?.cookieDomain  
    && window.WATCHTOWER.cookieDomain !== "#{WATCHTOWER_COOKIE_DOMAIN}"
    ? window.WATCHTOWER.cookieDomain 
    : process.env.REACT_APP_WATCHTOWER_COOKIE_DOMAIN,
}

export { oktaAuthConfig, oktaSignInConfig, appConfig, featureFlags, branding, watchtower };
